import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import NewsletterForm from "@/components/NewsletterForm";
import { PHONE, PHONE_TEL } from "@/lib/api";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-sand bg-espresso text-cream">
      <div className="border-b border-cream/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 py-14 md:flex-row md:items-center md:justify-between lg:px-12">
          <div>
            <p className="font-serif text-2xl font-light lg:text-3xl">
              L'idée brunch du mois, <span className="italic text-terracotta">dans votre boîte mail.</span>
            </p>
            <p className="mt-2 text-sm text-cream/60">Une recette de l'atelier, une astuce, une offre — une fois par mois, jamais plus.</p>
          </div>
          <NewsletterForm />
        </div>
      </div>
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-20 md:grid-cols-12 lg:px-12">
        <div className="md:col-span-5">
          <p className="font-serif text-3xl font-light tracking-tight">
            Gourmandise <span className="italic text-terracotta">Traiteur</span>
          </p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">
            L'art du brunch livré à domicile. Des produits frais, une présentation
            soignée et le service d'un vrai traiteur — à Lyon comme dans la Drôme.
          </p>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-cream/40">
            Nos ateliers
          </p>
          <div className="mt-6 space-y-4 text-sm text-cream/80">
            <p className="flex items-start gap-3" data-testid="footer-address-lyon">
              <MapPin size={16} strokeWidth={1.5} className="mt-0.5 shrink-0 text-terracotta" />
              PARC du Chêne, 69500 Bron — Métropole de Lyon
            </p>
            <p className="flex items-start gap-3" data-testid="footer-address-valence">
              <MapPin size={16} strokeWidth={1.5} className="mt-0.5 shrink-0 text-terracotta" />
              105 rue des Mourettes, 26000 Valence — Drôme
            </p>
            <a
              href={PHONE_TEL}
              data-testid="footer-phone"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-terracotta"
            >
              <Phone size={16} strokeWidth={1.5} className="shrink-0 text-terracotta" />
              {PHONE}
            </a>
            <a
              href="mailto:devis@gourmandise-traiteur.fr"
              data-testid="footer-email"
              className="flex items-center gap-3 transition-colors duration-300 hover:text-terracotta"
            >
              <Mail size={16} strokeWidth={1.5} className="shrink-0 text-terracotta" />
              devis@gourmandise-traiteur.fr
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-cream/40">
            Navigation
          </p>
          <nav className="mt-6 flex flex-col gap-3 text-sm text-cream/80">
            <Link to="/lyon" data-testid="footer-link-lyon" className="transition-colors duration-300 hover:text-terracotta">Brunch à Lyon</Link>
            <Link to="/drome" data-testid="footer-link-drome" className="transition-colors duration-300 hover:text-terracotta">Brunch dans la Drôme</Link>
            <Link to="/evenements" data-testid="footer-link-evenements" className="transition-colors duration-300 hover:text-terracotta">Événements</Link>
            <Link to="/livraison-petit-dejeuner" data-testid="footer-link-petit-dejeuner" className="transition-colors duration-300 hover:text-terracotta">Petit-déjeuner livré</Link>
            <Link to="/brunch-entreprise" data-testid="footer-link-entreprise" className="transition-colors duration-300 hover:text-terracotta">Brunch d'entreprise</Link>
            <Link to="/plateaux-repas-lyon" data-testid="footer-link-plateaux-repas" className="transition-colors duration-300 hover:text-terracotta">Plateaux repas à Lyon</Link>
            <Link to="/plateaux-repas-valence" data-testid="footer-link-plateaux-repas-valence" className="transition-colors duration-300 hover:text-terracotta">Plateaux repas à Valence</Link>
            <Link to="/brunch-airbnb" data-testid="footer-link-airbnb" className="transition-colors duration-300 hover:text-terracotta">Brunch pour Airbnb</Link>
            <Link to="/brunch-lendemain-mariage" data-testid="footer-link-mariage" className="transition-colors duration-300 hover:text-terracotta">Lendemain de mariage</Link>
            <Link to="/brunch-halloween" data-testid="footer-link-halloween" className="transition-colors duration-300 hover:text-terracotta">Brunch d'Halloween</Link>
            <Link to="/brunch-noel" data-testid="footer-link-noel" className="transition-colors duration-300 hover:text-terracotta">Brunch de Noël</Link>
            <Link to="/blog" data-testid="footer-link-blog" className="transition-colors duration-300 hover:text-terracotta">Journal & recettes</Link>
            <Link to="/commander" data-testid="footer-link-commander" className="transition-colors duration-300 hover:text-terracotta">Commander</Link>
            <Link to="/devis" data-testid="footer-link-devis" className="transition-colors duration-300 hover:text-terracotta">Devis sur mesure</Link>
            <Link to="/mentions-legales" data-testid="footer-link-legal" className="transition-colors duration-300 hover:text-terracotta">Mentions légales</Link>
          </nav>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 text-xs text-cream/40 md:flex-row md:items-center md:justify-between lg:px-12">
          <p data-testid="footer-siren">Gourmandise Traiteur — SIREN 752 128 645</p>
          <p>Commandez la veille pour le lendemain · Jour J : {PHONE}</p>
          <Link to="/admin" data-testid="footer-link-admin" className="transition-colors duration-300 hover:text-terracotta">Espace pro</Link>
        </div>
      </div>
    </footer>
  );
}
